import React, { useEffect } from "react"
import { withFormsy } from "formsy-react"
import { MultiSelect } from "shared/multiSelects"

const FormsyUserMultiSelect = withFormsy(({
  setValue,
  isFormSubmitted,
  isPristine,
  setShowErrors,
  values,
  ...rest
}) => {
  useEffect(() => {
    setShowErrors(isFormSubmitted || !isPristine)
  }, [isFormSubmitted, isPristine, setShowErrors])

  return (
    <MultiSelect
      isFormSubmitted={isFormSubmitted}
      isPristine={isPristine}
      onChange={(newValues) => setValue({ user_ids: newValues })}
      values={values}
      {...rest}
    />
  )
})

FormsyUserMultiSelect.displayName = "FormsyUserMultiSelect"

export default FormsyUserMultiSelect
